module.exports = __webpack_public_path__ + "static/img/submitReview.9fb32c9f.png";